<script setup>
import { computed } from 'vue'

const props = defineProps({
  // each entry is either a plain string label, or { label, class } for per-column classes (e.g. text-right)
  columns:     { type: Array, required: true },
  headerClass: { type: String, default: '' }, // extra classes applied to every th, e.g. "pt-4"
})

const normalizedColumns = computed(() =>
  props.columns.map(column => (
    typeof column === 'object' && column !== null
      ? { label: column.label ?? '', class: column.class ?? '' }
      : { label: column, class: '' }
  ))
)
</script>

<template lang="pug">
tr
  th.text-lg.font-semibold(
    v-for="(column, index) in normalizedColumns"
    :key="index"
    :class="[headerClass, column.class]"
  ) {{ column.label }}
</template>
